import { render, staticRenderFns } from "./CodingRules.vue?vue&type=template&id=3de0c1c8&scoped=true"
import script from "./CodingRules.vue?vue&type=script&lang=js"
export * from "./CodingRules.vue?vue&type=script&lang=js"
import style0 from "./CodingRules.vue?vue&type=style&index=0&id=3de0c1c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de0c1c8",
  null
  
)

export default component.exports